import { theme } from 'lib/theme';

import { differenceInCalendarDays } from 'date-fns';

import { AvailabilityCategoryText } from 'store/assessments/types';
import { isoDateStringToDate } from 'lib/riskbase';
import { FieldInstanceWithFormattedAutoId } from 'types/types';

export type CheckAvailabilityCategory = null | {
  text: AvailabilityCategoryText;
  iconColor: string;
  backgroundColour?: string;
};

export const getCheckAvailabilityCategory = (
  firstAvailabilityStart: Date | undefined,
  now: Date,
  isBackground?: boolean,
): CheckAvailabilityCategory => {
  if (!firstAvailabilityStart) {
    return null;
  }
  const dayDifference = differenceInCalendarDays(firstAvailabilityStart, now);

  if (dayDifference === 0) {
    return {
      text: 'Today',
      iconColor: theme.colors.green,
      backgroundColour: isBackground ? theme.colors.green10 : undefined,
    };
  }

  if (dayDifference === 1) {
    return {
      text: 'Tomorrow',
      iconColor: theme.colors.orange,
      backgroundColour: isBackground ? theme.colors.orange10 : undefined,
    };
  }

  if (dayDifference <= 7) {
    return {
      text: 'Next 7 Days',
      iconColor: theme.colors.blue,
      backgroundColour: isBackground ? theme.colors.blue10 : undefined,
    };
  }

  return null;
};

export const filterByAvailabilityCategory = (
  instances: Record<string, FieldInstanceWithFormattedAutoId>,
  filterAvailabilityCategories: AvailabilityCategoryText[],
  now: Date,
): Record<string, FieldInstanceWithFormattedAutoId> => {
  return Object.fromEntries(
    Object.entries(instances).filter(([, instance]) => {
      const instanceAvailabilityCategories =
        new Set<AvailabilityCategoryText>();
      Object.values(instance.checks || {}).forEach((check) => {
        const availabilityCategoryText = getCheckAvailabilityCategory(
          check.availability?.[0]?.startDateTime
            ? isoDateStringToDate(check.availability?.[0]?.startDateTime)
            : undefined,
          now,
        )?.text;
        if (availabilityCategoryText) {
          instanceAvailabilityCategories.add(availabilityCategoryText);
        }
      });
      // OR between categories
      return filterAvailabilityCategories.some((category) =>
        category === 'Next 7 Days'
          ? instanceAvailabilityCategories.has('Today') ||
            instanceAvailabilityCategories.has('Tomorrow') ||
            instanceAvailabilityCategories.has('Next 7 Days')
          : instanceAvailabilityCategories.has(category),
      );
    }),
  );
};
